// Generated by purs version 0.15.15
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var underline = [ "text-decoration: underline" ];
var style = /* #__PURE__ */ (function () {
    var $5 = Data_Array.foldMap(Data_Monoid.monoidString)(function (v) {
        return v + "; ";
    });
    return function ($6) {
        return Halogen_HTML_Properties.style($5($6));
    };
})();
var shadowed = [ "box-shadow: 0 0 0.2em 0.1em black" ];
var rounded = [ "border-radius: 0.5em" ];
var padding_vertical_small = [ "padding: 0.5em 0" ];
var padding_vertical_big = [ "padding: 1.0em 0" ];
var padding_small = [ "padding: 0.5em" ];
var padding_horizontal_small = [ "padding: 0 1.0em" ];
var padding_horizontal_big = [ "padding: 0 1.0em" ];
var padding_big = [ "padding: 1em" ];
var margin_small = [ "margin: 0.5em" ];
var italic = [ "font-style: italic" ];
var horizontal_bar = [ "width: 100%", "height: 2px", "background-color: black", "border-radius: 50px" ];
var hidden = [ "display: none", "visibility: hidden" ];
var font_size_small = [ "font-size: 0.8em" ];
var font_prose = [ "font-family: serif" ];
var font_fancy = [ "font-family: cursive" ];
var font_code = [ "font-family: monospace" ];
var flex_row = [ "display: flex", "flex-direction: row", "gap: 0.5em" ];
var flex_column = [ "display: flex", "flex-direction: column", "gap: 0.5em" ];
var color_error = [ "color: red" ];
var button_secondary = /* #__PURE__ */ append1(rounded)([ "border: none", "background-color: gray", "color: white", "padding: 0.2em 0.8em", "user-select: none" ]);
var button = /* #__PURE__ */ append1(rounded)([ "border: none", "background-color: black", "color: white", "padding: 0.2em 0.8em", "user-select: none" ]);
var boundaries = /* #__PURE__ */ append1(rounded)([ "box-shadow: 0.1em 0 0 0 rgba(0, 0, 0, 0.5) inset" ]);
var bold = [ "font-weight: bold" ];
export {
    style,
    flex_row,
    flex_column,
    rounded,
    padding_big,
    padding_vertical_small,
    padding_vertical_big,
    padding_horizontal_small,
    padding_horizontal_big,
    padding_small,
    margin_small,
    shadowed,
    font_code,
    font_prose,
    font_fancy,
    bold,
    italic,
    underline,
    font_size_small,
    boundaries,
    button,
    button_secondary,
    color_error,
    hidden,
    horizontal_bar
};
